import EditableHero from "@/components/editor/EditableHero";

const Hero = () => {
  return <EditableHero />;
};

export default Hero;